import React, { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import BoxPort, { buildHuntGroupLabelMap } from './BoxPort';
import { normalizePortKey } from '../../../../../lib/utils';
import './EpikBoxPorts.css';
import { portConfig, updateSipPri, getPortsRegStatus, fetchAvailableOobBTNs } from '../../../../../actions/EpikBoxes';
import BoxSipPri from '../BoxSipPri/BoxSipPri';
import Spinner from '../../../../Spinner/Spinner';
import ExternalAtaPorts from './ExternalAtaPorts';
import { DEVICE_LOCK_BY_SOMEONE } from '../../../../../lib/constants';
import { toast } from 'react-toastify';
import utils from '../../../../../lib/utils';
import { useUnifiedFetch } from '../../../../../hooks'
import ConfirmationModal from '../../../../ConfirmationModal';
import { getPermissionForComponent } from '../../../../../utils/permissionsUtils';
import activated from '../../../../../Res/Icon/activated.png';
import TooltipIcon from '../../TooltipIcon/TooltipIcon';

export function obisToPort(obis, lastUpdate) {
  const lastUpdated = new Date(lastUpdate);
  const portDefault = {
    boxPortNumber: '',
    serviceName: '',
    connected: '',
    remoteHost: '',
    ipAddress: '',
    remotePort: '',
    authName: '',
    assignedNumber: '',
    monitored: true,
  };
  return obis.reduce((acc, obi, index) => {
    acc.push({
      ...portDefault,
      ...{ boxPortNumber: obi?.port1?.boxPortNumber },
      ...{ lastUpdated },
      ...{ status: obi?.status },
      ...{ obiIndex: index },
      ...{ portKey: 'port1' },
      ...obi.port1,
    });
    acc.push({
      ...portDefault,
      ...{ boxPortNumber: obi?.port2?.boxPortNumber },
      ...{ lastUpdated },
      ...{ status: obi?.status },
      ...{ obiIndex: index },
      ...{ portKey: 'port2' },
      ...obi.port2,
    });
    return acc;
  }, []);
}

function ataToPort(ata, lastUpdate) {
  const lastUpdated = new Date(lastUpdate);
  const portDefault = {
    boxPortNumber: '',
    serviceName: '',
    connected: '',
    remoteHost: '',
    ipAddress: '',
    remotePort: '',
    authName: '',
    assignedNumber: '',
    monitored: true,
  };
  return ata.reduce((acc, obi, index) => {
    if (ata[0].externalAtaPorts === '8') {
      // push 8 ports to acc and return acc
      for (let i = 1; i <= 8; i++) {
        acc.push({
          ...portDefault,
          ...{ boxPortNumber: obi[`port${i}`]?.boxPortNumber },
          ...{ lastUpdated },
          // ...{ status: obi?.status },
          ...{ obiIndex: index },
          ...{ portKey: `port${i}` },
          ...obi[`port${i}`],
        });
      }
    } else {
      // push 4 ports to acc and return acc
      for (let i = 1; i <= 24; i++) {
        acc.push({
          ...portDefault,
          ...{ boxPortNumber: obi[`port${i}`]?.boxPortNumber },
          ...{ lastUpdated },
          // ...{ status: obi?.status },
          ...{ obiIndex: index },
          ...{ portKey: `port${i}` },
          ...obi[`port${i}`],
        });
      }
    }
    return acc;
  }, []);
}

const EpikBoxPorts = ({
  box,
  obis,
  onSelect,
  onAtaSelect,
  selected,
  numbers,
  boxDetails,
  portConfig,
  onImportConfirm,
  importFinalList,
  onAssignAvailablePress,
  numberToFilter,
  onAvailableSave,
  finalSelectedList,
  state,
  setState,
  onBandManagementCall,
  oobList,
  OOBManagerHandler,
  portMode,
  oobSavedProfiles
}) => {
  const [isLoaderOpen, setIsLoaderOpen] = useState(false);
  const token = localStorage.getItem('jwtToken') || null;
  const priSettings = useSelector(state => state.AppState.priSipData?.prisip?.priSettings);
  const sipSettings = useSelector(state => state.AppState.priSipData?.prisip?.sipSettings);
  const resetPortE911 = true;
  const dispatch = useDispatch();
  const ports = obisToPort(obis, box.lastUpdated);
  const huntGroupLabelMap = buildHuntGroupLabelMap(ports);
  const lockStatusBox = useSelector(state => state.UIState.epikBoxes.lockStatusEpikBox);
  const [countdown, setCountdown] = useState(0);
  const [isBoxPortsStatLoading, setIsBoxPortsStatLoading] = useState(false)
  const [boxPortsStatus, setBoxPortsStatus] = useState(null)
  const [boxLockWarning, setBoxLockWarning] = useState(false);

  const user = useSelector(state => state.AppState.user);
  const oobOrderedBtns = useSelector(state => state.AppState.boxDetails.oobOrderedBtns);
  const outBandManagement = getPermissionForComponent('outBandManagement',user.permissionsGroup);

  const assignedUsbs = oobList && oobList.assignedUsbs || [];

  // Filter out assigned USBs that are not in disconnected USBs
  const activeUsbs = assignedUsbs.filter(assignedUsb => !assignedUsb?.disconnected);

  const {
    isLoading,
    data: oobmPortProfiles,
    fetchData: fetchingOobmProfiles
  } = useUnifiedFetch(`oob/${boxDetails?._id}/fetchSavedProfiles`, false);

  const timer = utils.calculateEpiFirmwareUpdateTimer(boxDetails?.epiFirmwareUpdateTimer);

  useEffect(() => {
    let portsArray = obisToPort(obis, box.lastUpdated);
    const registerdPort = portsArray.reduce((total, port) => total + port.registered ? 1 : 0, 0);

    const portCount = { registerdPort, totalPorts: portsArray.length };
    // setState({ ...state, portCount: { ...portCount } });

    if (box.OBEnable && box._id === window.location.pathname.split('/').pop() && !box?.serialNumber?.startsWith('E-')) {
      OOBManagerHandler(false);
    }
  }, [box.OBEnable, box._id]);

  useEffect(() => {

    if(box._id === window.location.pathname.split('/').pop() && portMode === 'ports' && !boxDetails?.serialNumber?.startsWith('E-')){
      getPortsStatus(box._id)
    }
    
  }, [portMode, box._id])
  

  useEffect(() => {
    let intervalId;

    const startCountdown = () => {
      intervalId = setInterval(() => {
        // Calculate remaining time in seconds

        const newData = new Date();
        const lastClickDate = new Date(boxDetails?.epiFirmwareUpdateTimer);
        const mintDifference = newData?.getTime() - lastClickDate?.getTime();
        const epiFwUpdateTimer = mintDifference / 60000;
        const timeRemaining = 15 - epiFwUpdateTimer;

        // Convert timeRemaining into minutes and seconds
        const minutes = Math.floor(timeRemaining);
        const seconds = Math.round((timeRemaining - minutes) * 60);
        const formattedTime = `${minutes}min ${seconds}sec`;

        // Update countdown
        setCountdown(formattedTime);
      }, 1000);
    };

    const stopCountdown = () => {
      clearInterval(intervalId);
    };

    // Start countdown when timer is available
    if (boxDetails?.epiFirmwareUpdateTimer && !timer) {
      startCountdown();
    }

    // Stop countdown and clear interval on component unmount
    return () => {
      stopCountdown();
    };
  }, [boxDetails?.epiFirmwareUpdateTimer, timer]);

  async function getPortsStatus(boxId){
    setIsBoxPortsStatLoading(true)
    const portsRegStatus = await dispatch(getPortsRegStatus(token, boxId))
    if(portsRegStatus){
      setBoxPortsStatus(portsRegStatus.response)
    }
    setIsBoxPortsStatLoading(false)
  }

  const externalPorts = ataToPort(box?.externalAta || [], box?.lastUpdate || new Date());

  if (ports.length === 0 && !box.OBEnable) {
    return (
      <>
        {boxDetails.serialNumber?.startsWith('E-') ? (
          <div className="message">
            EPI’s have been moved to primary box {` ${boxDetails?.masterBox?.displayName || ''}`}
          </div>
        ) : (
          <div className="message">
            No EPI’s added to EPIK Device
          </div>
        )}
        {boxDetails?.masterBox ? (
          <a
            hidden={!boxDetails.expansionBox}
            className="message"
            style={{ cursor: 'pointer' }}
            href={`/boxes/${boxDetails?.masterBox?._id}?company=${boxDetails.masterBox.assignedTo}`}
          >
            <h6
              style={{
                margin: '5px 0px 5px 0px',
                textAlign: 'center',
                color: '#212529',
              }}
            >
              EPI’s have been moved to primary box {` ${boxDetails?.masterBox?.displayName || ''}`}
            </h6>
          </a>
        ) : null}
      </>
    );
  }
  const handleUpdateObi = async (reset, portData) => {
    const updatedPort = { ...portData, e911Number: reset ? '' : boxDetails.e911Number };
    const portKey = updatedPort.portKey;
    obis[updatedPort.obiIndex][portKey] = updatedPort;
    const portNumber = updatedPort.boxPortNumber.split(' ')[1];
    const body = {
      vpnAddress: boxDetails.vpnAddress,
      selectedPort: portNumber,
      e911Number: updatedPort.e911Number,
      obiObj: obis[updatedPort.obiIndex],
    };
    portConfig(token, body);
  };

  const updateSipPriSetting = async (numberSettings, isPri) => {
    setIsLoaderOpen(true);
    const dataToAppend = isPri ? { ...priSettings } : { ...priSettings };
    const settings = {
      ...dataToAppend,
      numberSettings: numberSettings || [],
    };
    await dispatch(updateSipPri(token, box?._id, isPri, settings));
    setIsLoaderOpen(false);
  };

  const oobmHander = async () => {
    await onBandManagementCall(true)
    const saveProfiles = await fetchingOobmProfiles()
    oobSavedProfiles(saveProfiles)
    await dispatch(fetchAvailableOobBTNs(token, box._id));
  }

  const lockBoxButton = async () => {
    const element = document.getElementById('test-lock-icon');
    if (element) {
      // Simulate a click event
      element.click();
    } else {
      console.error('Element with id "test-lock-icon" not found.');
    }
  };

  const isESeries = box?.serialNumber?.startsWith('E-')

  return (
    <>
      {!timer && (
        <div className='overlay-text'>
          <span className='firmware-text'>EPI Firmware update in progress. Please wait {countdown}.</span>
        </div>
      )}
    <div className={`${timer ? 'portsContainer' : 'portsContainer firmware-update-running'}`}>
        {isLoaderOpen && <Spinner />}
        {ports.map(port => {
          return (
            <BoxPort
              key={Math.random()}
              box={box}
              resetE911={data => handleUpdateObi(resetPortE911, data)}
              assignE911ToPort={data => handleUpdateObi(false, data)}
              onPortSelect={onSelect}
              selected={(selected && selected.boxPortNumber) === port.boxPortNumber}
              port={port}
              numbers={numbers}
              boxPortsStatus={boxPortsStatus}
              isBoxPortsStatLoading={isBoxPortsStatLoading}
              huntGroupLabel={huntGroupLabelMap[normalizePortKey(port.boxPortNumber)]}
              />
          );
        })}

        {externalPorts?.map(port => {
          return (
            <ExternalAtaPorts
              key={Math.random()}
              box={box}
              onPortSelect={onAtaSelect}
              // onPortSelect={onSelect}
              selected={(selected && selected.boxPortNumber) === port.boxPortNumber}
              port={port} />
          );
        })}

        {(box?.features?.cas || box?.features?.sip) && !box?.myEpik && (
          <BoxSipPri
            title="CAS"
            MainTitle="CAS Trunking"
            onAssignAvailablePress={onAssignAvailablePress}
            onImportConfirm={onImportConfirm}
            importFinalList={importFinalList}
            numberToFilter={numberToFilter}
            onAvailableSave={onAvailableSave}
            finalSelectedList={finalSelectedList}
            updatePriSipSetting={updateSipPriSetting}
            numberSettings={priSettings?.numberSettings} />
        )}

        {box?.features?.pri && !box?.myEpik && (
          <BoxSipPri
            title="PRI"
            MainTitle="PRI Trunking"
            onAssignAvailablePress={onAssignAvailablePress}
            onImportConfirm={onImportConfirm}
            importFinalList={importFinalList}
            numberToFilter={numberToFilter}
            onAvailableSave={onAvailableSave}
            finalSelectedList={finalSelectedList}
            updatePriSipSetting={updateSipPriSetting}
            numberSettings={priSettings?.numberSettings} />
        )}

          {box?.OBEnable && !isESeries && outBandManagement &&
          <div className="boxPortContainer"
            onClick={() => {
              if(lockStatusBox.locked) {
                toast.error(DEVICE_LOCK_BY_SOMEONE)
              } else if (document.getElementById('test-time-remaining')?.hasAttribute('hidden')) {
                setBoxLockWarning(true);
              } else {
                oobmHander();
              }
            }}
          >
            <div style={{ width: '100%' }}>
              {box?.oobPortActivated ? (
                <div  className='iconsHeaderContainer'>
                  <div className="portActivatedIcon">
                      <TooltipIcon
                        tipId={`oobm_activationStatus`}
                        imgSrc={activated}
                        displayData='Port Activated'
                        placement={'right'}
                        customStyle={{
                          height: '20px',
                          }}
                        customClass='portActivatedTooltip'
                      />
                  </div>
                </div>
              ) : null}
            </div>
            <div className="portLabel" id='oobm'>OOBM</div>
            <div className="portInfo">
              <span id="port-name-value">Port Discovered</span>
              <span id="port-name-value">{activeUsbs?.length} </span>
            </div>
            <div className="portInfo">
              <span id="port-name-value">Numbers Assigned</span>
              <span id="port-name-value">{oobOrderedBtns?.filter(btn => btn?.usbPort && !btn?.usbPort?.diconnected)?.length} </span>
            </div>
          </div>}
          {boxLockWarning && (
            <ConfirmationModal
              bodyText="You are attempting to make changes to a device that is not currently locked for editing. To prevent conflicting changes, please lock the device before proceeding."
              headerText="Device Lock Required"
              confirmBtnText="Lock & Edit"
              close="No"
              isOpen={boxLockWarning}
              onCancel={() => setBoxLockWarning(false)}
              onConfirm={() => {
                lockBoxButton();
                setBoxLockWarning(false);
              }}
            />
          )}
      </div></>
  );
};

const mapDispatchToProps = dispatch => ({
  portConfig: (token, body) => dispatch(portConfig(token, body)),
});
const mapStateToProps = state => ({
  addressModalData: state.AppState.provisioning.address,
  boxDetails: state.AppState.boxDetails.box,
  oobList: state.AppState.boxDetails.oobList,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EpikBoxPorts);
